import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { QuoteQuestionsPage } from './quote-questions.page';

const routes: Routes = [
  {
    path: '',
    component: QuoteQuestionsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class QuoteQuestionsPageRoutingModule {}
